import { z } from 'zod';

export const GithubStatusSchema = z.object({
	status: z.enum(['connected', 'expired', 'not_connected']),
	selectedOrgs: z.array(z.string()).optional(),
	selectedRepos: z.array(z.string()).optional(),
});
export type GithubStatus = z.infer<typeof GithubStatusSchema>;

export const GithubAuthorizeSchema = z.object({
	redirectUrl: z.string(),
});
export type GithubAuthorize = z.infer<typeof GithubAuthorizeSchema>;

export const GithubDisconnectSchema = z.object({
	disconnected: z.boolean(),
});
export type GithubDisconnect = z.infer<typeof GithubDisconnectSchema>;

export const GithubRepoSchema = z.object({
	fullName: z.string(),
	name: z.string(),
	owner: z.string(),
	ownerType: z.enum(['User', 'Organization']),
	private: z.boolean(),
	description: z.string().nullable(),
});
export type GithubRepo = z.infer<typeof GithubRepoSchema>;

export const GithubReposResponseSchema = z.object({
	repos: z.array(GithubRepoSchema),
	totalCount: z.number(),
});

export const GithubPreferencesSchema = z.object({
	selectedOrgs: z.array(z.string()),
	selectedRepos: z.array(z.string()),
});
export type GithubPreferences = z.infer<typeof GithubPreferencesSchema>;

export const GithubCollaboratorReferenceSchema = z.object({
	referenceType: z.literal('github_pull_request'),
	referenceUrl: z.string(),
});
export type GithubCollaboratorReference = z.infer<typeof GithubCollaboratorReferenceSchema>;

export const GithubCollaboratorSchema = z.object({
	githubLogin: z.string(),
	authoredPullRequestsCount: z.number(),
	reviewedPullRequestsCount: z.number(),
	commentedPullRequestsCount: z.number(),
	reviewCount: z.number(),
	commentCount: z.number(),
	activityCount: z.number(),
	references: z.array(GithubCollaboratorReferenceSchema),
});
export type GithubCollaborator = z.infer<typeof GithubCollaboratorSchema>;

export const GithubCollaboratorPullRequestSchema = z.object({
	repo: z.string(),
	number: z.number(),
	title: z.string(),
	state: z.string(),
	url: z.string(),
	author: z.string(),
	createdAt: z.string(),
	updatedAt: z.string(),
	mergedAt: z.string().nullable(),
});
export type GithubCollaboratorPullRequest = z.infer<typeof GithubCollaboratorPullRequestSchema>;

export const GithubCollaboratorsResponseSchema = z.object({
	viewerLogin: z.string(),
	collaborators: z.array(GithubCollaboratorSchema),
	pullRequests: z.array(GithubCollaboratorPullRequestSchema),
	totalCount: z.number(),
	hasMore: z.boolean(),
});
export type GithubCollaboratorsResponse = z.infer<typeof GithubCollaboratorsResponseSchema>;
